// VHM Renovation multilingual content (NL / FR / EN / ES).
// Wizard option keys match backend scoring.py / labels_nl.py.

const NL = {
  meta: {
    title: "VHM Renovation | Schilder- & afwerkingswerken — Sint-Genesius-Rode, Brussel & Brabant",
    description:
      "Schilder- en afwerkingswerken: binnen- en buitenschilderwerk, gyproc, plamuren en vloerbekleding. Netjes afgewerkt, met 2 jaar garantie. Vraag uw offerte aan.",
  },
  common: {
    requestQuote: "Vraag een offerte aan",
    quoteShort: "Offerte aanvragen",
    callUs: "Bel VHM Renovation",
    viewWork: "Bekijk ons werk",
    back: "Vorige",
    next: "Volgende",
    submit: "Verstuur aanvraag",
    sending: "Verzenden…",
    optional: "optioneel",
    stepOf: "Stap {n} van {total}",
  },
  nav: [
    { label: "Diensten", page: "services" },
    { label: "Realisaties", page: "realisaties" },
    { label: "Werkwijze", page: "process" },
    { label: "Regio", page: "region" },
  ],
  hero: {
    badge: "Schilder- & afwerkingswerken · 15+ jaar ervaring",
    titleTop: "Schilder- & afwerkingswerken",
    titleMain: "Een strakke, verzorgde afwerking — binnen en buiten.",
    subtitle:
      "VHM Renovation verzorgt schilderwerk, gyproc, plamuren en vloerbekleding voor woningen, appartementen en bedrijfsruimtes. Vakwerk met oog voor detail, netjes opgeleverd.",
    primary: "Vraag een offerte aan",
    secondary: "Bekijk ons werk",
    stats: [
      { v: "15+", l: "Jaar ervaring" },
      { v: "2 jaar", l: "Garantie op het werk" },
      { v: "BA", l: "Verzekerd" },
    ],
  },
  services: {
    label: "Diensten",
    title: "Schilder- & afwerkingswerken",
    intro:
      "Van voorbereiding tot de laatste laag: VHM Renovation levert een nette, duurzame afwerking met kwalitatieve materialen.",
    items: [
      { name: "Binnenschilderwerk", desc: "Muren en plafonds strak geschilderd, standaard in minstens twee lagen." },
      { name: "Buitenschilderwerk & gevel", desc: "Gevels, kozijnen en houtwerk, weerbestendig afgewerkt." },
      { name: "Gyproc-wanden", desc: "Plaatsen van gipswanden en scheidingswanden (cloisons)." },
      { name: "Plamuren & schuren", desc: "Perfect vlakke muren en plafonds, klaar om te schilderen." },
      { name: "Herstellingen", desc: "Scheuren, gaten en oneffenheden vakkundig hersteld." },
      { name: "Vloerbekleding", desc: "Plaatsen en afwerken van vloerbekleding." },
      { name: "Behangwerk", desc: "Strak geplaatst behang, ook vliesbehang." },
      { name: "Voorbereiding & reiniging", desc: "Afplakken, afdekken en reinigen van alle oppervlakken." },
    ],
  },
  why: {
    label: "Waarom VHM Renovation",
    title: "Vakwerk met garantie, netjes opgeleverd",
    items: [
      { title: "15+ jaar ervaring", desc: "Jarenlange ervaring in schilder- en afwerkingswerken." },
      { title: "2 jaar garantie", desc: "Op alle uitgevoerde werken — op vakmanschap én materiaal." },
      { title: "Verzekerd (BA)", desc: "Volledig verzekerd tijdens de volledige uitvoering van de werf." },
      { title: "Nette, stipte werf", desc: "Een vaste contactpersoon en een propere, veilige werf." },
    ],
  },
  process: {
    label: "Werkwijze",
    title: "Zo verloopt uw project",
    intro: "Een duidelijk traject in vier stappen — transparant en zonder verrassingen.",
    steps: [
      { title: "Aanvraag", desc: "U beschrijft uw project via ons formulier — inclusief foto's." },
      { title: "Plaatsbezoek & advies", desc: "Wij bekijken de oppervlakken en geven eerlijk advies." },
      { title: "Heldere offerte", desc: "U ontvangt een duidelijke offerte op maat van uw project." },
      { title: "Uitvoering & oplevering", desc: "Wij voeren de werken netjes uit en leveren proper op." },
    ],
  },
  realisaties: {
    label: "Realisaties",
    title: "Werk dat voor zich spreekt",
    intro:
      "Een greep uit onze schilder- en afwerkingsprojecten. Kwaliteit die u ziet én voelt.",
    tags: ["Binnenschilderwerk", "Gevel & buiten", "Gyproc & afwerking", "Vloerbekleding"],
  },
  team: {
    label: "Vakmanschap",
    title: "Persoonlijk vakmanschap op elke werf",
    body: "Bij VHM Renovation werkt u met een vaste, ervaren vakman. Eén aanspreekpunt, duidelijke afspraken en een verzorgde afwerking van start tot oplevering.",
    points: ["15+ jaar ervaring", "Vaste contactpersoon", "Nette, veilige werf", "Kwalitatieve materialen"],
  },
  region: {
    label: "Werkgebied",
    title: "Actief in Sint-Genesius-Rode, Brussel-Zuid & omstreken",
    body:
      "VHM Renovation is gevestigd in Sint-Genesius-Rode en werkt in Brussel-Zuid, de Rand en Waals- & Vlaams-Brabant.",
    note: "Buiten deze regio? Neem gerust contact op — we bekijken elk project.",
    cities: ["Sint-Genesius-Rode", "Ukkel", "Linkebeek", "Drogenbos", "Beersel", "Waterloo", "Halle", "Brussel"],
  },
  ctaBand: {
    title: "Klaar voor een strakke afwerking?",
    body: "Bezorg ons uw projectgegevens. Wij bekijken uw aanvraag en nemen contact op voor een offerte.",
    button: "Vraag een offerte aan",
    or: "of",
    call: "Bel VHM Renovation",
  },
  footer: {
    blurb: "Schilder- & afwerkingswerken voor woningen, appartementen en bedrijfsruimtes. Binnen en buiten, netjes afgewerkt.",
    contactLabel: "Contact",
    servicesLabel: "Diensten",
    services: ["Binnenschilderwerk", "Gevel & buiten", "Gyproc & plamuren", "Vloerbekleding"],
    areaLabel: "Werkgebied",
    area: "Sint-Genesius-Rode · Ukkel · Linkebeek · Drogenbos · Beersel · Waterloo · Halle · Brussel",
    legal: "© 2026 VHM Renovation — Schilder- & afwerkingswerken.",
    adminLink: "Beheer",
  },
  wizard: {
    heading: "Offerteaanvraag",
    sub: "Vertel ons over uw project. Hoe completer uw aanvraag, hoe beter wij ze kunnen inschatten.",
    steps: [
      { t: "Type project", s: "Wat wilt u laten doen?" },
      { t: "Omvang", s: "Hoe groot is het project?" },
      { t: "Werken", s: "Welke werken zijn nodig?" },
      { t: "Budget", s: "Uw geschatte budget" },
      { t: "Planning", s: "Wanneer wilt u starten?" },
      { t: "Locatie", s: "Waar bevindt het project zich?" },
      { t: "Foto's & contact", s: "Bijna klaar" },
    ],
    q: {
      type: "Wat wilt u laten uitvoeren?",
      size: "Hoe groot is het project ongeveer?",
      works: "Welke werken zijn nodig?",
      budget: "Wat is uw geschatte budget?",
      planning: "Wanneer wilt u starten?",
      location: "Wat is het projectadres?",
      contact: "Foto's, plannen en contactgegevens",
    },
    projectHint: "Meerdere opties mogelijk.",
    projectTypes: {
      woning: "Woning",
      appartement: "Appartement",
      nieuwbouw: "Nieuwbouw",
      handelsruimte: "Handels-/bedrijfsruimte",
      kantoor: "Kantoor",
      andere: "Andere",
    },
    size: {
      oppervlakte: "Geschatte oppervlakte (m²)",
      verdiepingen: "Aantal verdiepingen",
      kamers: "Aantal kamers/ruimtes",
      bouwjaar: "Bouwjaar",
      bewoond: "Is het pand momenteel bewoond?",
      renoType: "Volledig pand of enkele ruimtes?",
    },
    bewoond: { ja: "Ja", nee: "Nee", onbekend: "Onbekend" },
    renoType: { volledig: "Volledig pand", gedeeltelijk: "Enkele ruimtes", onzeker: "Nog niet zeker" },
    worksCats: {
      schilderwerk: "Schilderwerk",
      afwerking: "Gyproc & afwerking",
      voorbereiding: "Voorbereiding",
    },
    works: {
      binnen: "Binnenschilderwerk", buiten: "Buitenschilderwerk & gevel", plafonds: "Plafonds", behang: "Behangwerk",
      gyproc: "Gyproc-wanden plaatsen", plamuren: "Plamuren & schuren", herstellingen: "Herstellen scheuren & gaten", vloerbekleding: "Vloerbekleding plaatsen",
      reinigen: "Reinigen & ontvetten", afplakken: "Afplakken & afdekken", schuren: "Schuren & voorstrijken",
    },
    worksDesc: "Beschrijf kort wat u precies wilt laten uitvoeren.",
    worksDescPh: "Bv. living en gang schilderen (muren + plafond) en een gyproc-wand plaatsen…",
    budget: {
      lt10k: "Minder dan €10.000",
      "10-25k": "€10.000 – €25.000",
      "25-50k": "€25.000 – €50.000",
      "50-100k": "€50.000 – €100.000",
      "100-150k": "€100.000 – €150.000",
      "150-250k": "€150.000 – €250.000",
      gt250k: "Meer dan €250.000",
      unknown: "Nog geen budget bepaald",
    },
    budgetNote: "Dit is enkel een indicatie en helpt ons uw aanvraag beter in te schatten. Er wordt geen automatische prijs bepaald.",
    starttermijn: {
      asap: "Zo snel mogelijk",
      "1m": "Binnen 1 maand",
      "1-3m": "Binnen 1–3 maanden",
      "3-6m": "Binnen 3–6 maanden",
      "6-12m": "Binnen 6–12 maanden",
      later: "Later",
      unknown: "Nog niet bepaald",
    },
    deadlineQ: "Is er een gewenste opleverdatum of deadline?",
    deadlineYes: "Ja",
    deadlineNo: "Nee",
    deadlineDate: "Gewenste opleverdatum",
    plaatsbezoek: "Voorkeursdatum plaatsbezoek (optioneel)",
    loc: { straat: "Straat", huisnummer: "Nr.", postcode: "Postcode", gemeente: "Gemeente", land: "Land" },
    upload: {
      title: "Foto's en plannen",
      hint: "JPG, PNG, WebP of PDF · max. 10 bestanden",
      add: "Bestanden toevoegen",
      uploading: "Uploaden…",
      remove: "Verwijderen",
    },
    contact: {
      voornaam: "Voornaam", achternaam: "Achternaam", telefoon: "Telefoonnummer", email: "E-mailadres",
      bedrijf: "Bedrijfsnaam", btw: "BTW-nummer", opmerkingen: "Extra opmerkingen",
    },
    priceNote:
      "Een definitieve offerte wordt pas opgesteld na beoordeling van het project en, indien nodig, een plaatsbezoek.",
    errType: "Selecteer minstens één type.",
    errContact: "Vul uw voornaam, achternaam, telefoon en e-mailadres in.",
    errEmail: "Vul een geldig e-mailadres in.",
    errFail: "Verzenden mislukt. Probeer opnieuw of bel ons.",
  },
  confirmation: {
    title: "Bedankt voor uw aanvraag",
    body:
      "We hebben uw projectgegevens goed ontvangen. VHM Renovation bekijkt uw aanvraag en neemt contact met u op om de mogelijkheden en een eventueel plaatsbezoek te bespreken.",
    note:
      "Een definitieve offerte wordt pas opgesteld na beoordeling van het project en, indien nodig, een plaatsbezoek.",
    home: "Terug naar de startpagina",
  },
};

const FR = {
  meta: {
    title: "VHM Renovation | Peinture & travaux de finition — Rhode-Saint-Genèse, Bruxelles & Brabant",
    description:
      "Peinture et travaux de finition : peinture intérieure et extérieure, gyproc, enduits et revêtements de sol. Finition soignée, 2 ans de garantie. Demandez votre devis.",
  },
  common: {
    requestQuote: "Demandez un devis",
    quoteShort: "Demander un devis",
    callUs: "Appelez VHM Renovation",
    viewWork: "Voir nos travaux",
    back: "Précédent",
    next: "Suivant",
    submit: "Envoyer la demande",
    sending: "Envoi…",
    optional: "facultatif",
    stepOf: "Étape {n} sur {total}",
  },
  nav: [
    { label: "Services", page: "services" },
    { label: "Réalisations", page: "realisaties" },
    { label: "Méthode", page: "process" },
    { label: "Région", page: "region" },
  ],
  hero: {
    badge: "Peinture & finitions · 15+ ans d'expérience",
    titleTop: "Peinture & travaux de finition",
    titleMain: "Une finition soignée, à l'intérieur comme à l'extérieur.",
    subtitle:
      "VHM Renovation réalise peinture, gyproc, enduits et revêtements de sol pour maisons, appartements et espaces professionnels. Un travail soigné, avec le souci du détail.",
    primary: "Demandez un devis",
    secondary: "Voir nos travaux",
    stats: [
      { v: "15+", l: "Ans d'expérience" },
      { v: "2 ans", l: "Garantie sur les travaux" },
      { v: "RC", l: "Assuré" },
    ],
  },
  services: {
    label: "Services",
    title: "Peinture & travaux de finition",
    intro:
      "De la préparation à la dernière couche : VHM Renovation offre une finition nette et durable avec des matériaux de qualité.",
    items: [
      { name: "Peinture intérieure", desc: "Murs et plafonds peints, en principe en deux couches." },
      { name: "Peinture extérieure & façade", desc: "Façades, châssis et boiseries, finition résistante." },
      { name: "Cloisons en gyproc", desc: "Pose de cloisons et parois en plaques de plâtre." },
      { name: "Enduits & ponçage", desc: "Des murs parfaitement lisses, prêts à peindre." },
      { name: "Réparations", desc: "Fissures, trous et irrégularités réparés avec soin." },
      { name: "Revêtements de sol", desc: "Pose et finition de revêtements de sol." },
      { name: "Pose de papier peint", desc: "Papier peint posé nettement, intissé compris." },
      { name: "Préparation & nettoyage", desc: "Protection, bâchage et nettoyage des surfaces." },
    ],
  },
  why: {
    label: "Pourquoi VHM Renovation",
    title: "Un travail garanti, livré proprement",
    items: [
      { title: "15+ ans d'expérience", desc: "Des années d'expérience en peinture et finitions." },
      { title: "2 ans de garantie", desc: "Sur tous les travaux — main-d'œuvre et matériaux." },
      { title: "Assuré (RC)", desc: "Entièrement assuré pendant toute l'exécution du chantier." },
      { title: "Chantier net & ponctuel", desc: "Un interlocuteur fixe et un chantier propre et sûr." },
    ],
  },
  process: {
    label: "Méthode",
    title: "Le déroulement de votre projet",
    intro: "Un parcours clair en quatre étapes — transparent et sans surprises.",
    steps: [
      { title: "Demande", desc: "Décrivez votre projet via notre formulaire — photos incluses." },
      { title: "Visite & conseil", desc: "Nous examinons les surfaces et vous conseillons honnêtement." },
      { title: "Devis clair", desc: "Vous recevez un devis clair et sur mesure." },
      { title: "Exécution & livraison", desc: "Nous exécutons proprement et livrons net." },
    ],
  },
  realisaties: {
    label: "Réalisations",
    title: "Un travail qui parle de lui-même",
    intro: "Un aperçu de nos travaux de peinture et de finition. Une qualité qui se voit et se ressent.",
    tags: ["Peinture intérieure", "Façade & extérieur", "Gyproc & finition", "Revêtement de sol"],
  },
  team: {
    label: "Savoir-faire",
    title: "Un savoir-faire personnel sur chaque chantier",
    body: "Chez VHM Renovation, vous travaillez avec un artisan expérimenté et fixe. Un seul interlocuteur, des accords clairs et une finition soignée du début à la livraison.",
    points: ["15+ ans d'expérience", "Interlocuteur fixe", "Chantier propre et sûr", "Matériaux de qualité"],
  },
  region: {
    label: "Zone d'intervention",
    title: "Actif à Rhode-Saint-Genèse, Bruxelles-Sud & environs",
    body:
      "VHM Renovation est établie à Rhode-Saint-Genèse et intervient à Bruxelles-Sud, en périphérie et dans le Brabant wallon & flamand.",
    note: "En dehors de cette région ? Contactez-nous — nous étudions chaque projet.",
    cities: ["Rhode-Saint-Genèse", "Uccle", "Linkebeek", "Drogenbos", "Beersel", "Waterloo", "Hal", "Bruxelles"],
  },
  ctaBand: {
    title: "Prêt pour une finition impeccable ?",
    body: "Transmettez-nous les détails de votre projet. Nous étudions votre demande et vous recontactons pour un devis.",
    button: "Demandez un devis",
    or: "ou",
    call: "Appelez VHM Renovation",
  },
  footer: {
    blurb: "Peinture et travaux de finition pour maisons, appartements et espaces professionnels. Intérieur et extérieur, proprement finis.",
    contactLabel: "Contact",
    servicesLabel: "Services",
    services: ["Peinture intérieure", "Façade & extérieur", "Gyproc & enduits", "Revêtements de sol"],
    areaLabel: "Zone d'intervention",
    area: "Rhode-Saint-Genèse · Uccle · Linkebeek · Drogenbos · Beersel · Waterloo · Hal · Bruxelles",
    legal: "© 2026 VHM Renovation — Peinture & finitions.",
    adminLink: "Gestion",
  },
  wizard: {
    heading: "Demande de devis",
    sub: "Parlez-nous de votre projet. Plus votre demande est complète, mieux nous pouvons l'estimer.",
    steps: [
      { t: "Type de projet", s: "Que voulez-vous faire réaliser ?" },
      { t: "Ampleur", s: "Quelle est la taille du projet ?" },
      { t: "Travaux", s: "Quels travaux sont nécessaires ?" },
      { t: "Budget", s: "Votre budget estimé" },
      { t: "Planning", s: "Quand souhaitez-vous démarrer ?" },
      { t: "Lieu", s: "Où se situe le projet ?" },
      { t: "Photos & contact", s: "Presque terminé" },
    ],
    q: {
      type: "Que souhaitez-vous faire réaliser ?",
      size: "Quelle est approximativement la taille du projet ?",
      works: "Quels travaux sont nécessaires ?",
      budget: "Quel est votre budget estimé ?",
      planning: "Quand souhaitez-vous démarrer ?",
      location: "Quelle est l'adresse du projet ?",
      contact: "Photos, plans et coordonnées",
    },
    projectHint: "Plusieurs choix possibles.",
    projectTypes: {
      woning: "Maison",
      appartement: "Appartement",
      nieuwbouw: "Construction neuve",
      handelsruimte: "Espace commercial/pro",
      kantoor: "Bureau",
      andere: "Autre",
    },
    size: {
      oppervlakte: "Superficie estimée (m²)",
      verdiepingen: "Nombre d'étages",
      kamers: "Nombre de pièces",
      bouwjaar: "Année de construction",
      bewoond: "Le bien est-il habité actuellement ?",
      renoType: "Bien entier ou quelques pièces ?",
    },
    bewoond: { ja: "Oui", nee: "Non", onbekend: "Inconnu" },
    renoType: { volledig: "Bien entier", gedeeltelijk: "Quelques pièces", onzeker: "Pas encore sûr" },
    worksCats: {
      schilderwerk: "Peinture",
      afwerking: "Gyproc & finition",
      voorbereiding: "Préparation",
    },
    works: {
      binnen: "Peinture intérieure", buiten: "Peinture extérieure & façade", plafonds: "Plafonds", behang: "Papier peint",
      gyproc: "Pose de cloisons gyproc", plamuren: "Enduits & ponçage", herstellingen: "Réparation fissures & trous", vloerbekleding: "Pose de revêtement de sol",
      reinigen: "Nettoyage & dégraissage", afplakken: "Protection & bâchage", schuren: "Ponçage & primaire",
    },
    worksDesc: "Décrivez brièvement ce que vous souhaitez faire réaliser.",
    worksDescPh: "P.ex. peindre le séjour et le couloir (murs + plafond) et poser une cloison gyproc…",
    budget: {
      lt10k: "Moins de €10.000",
      "10-25k": "€10.000 – €25.000",
      "25-50k": "€25.000 – €50.000",
      "50-100k": "€50.000 – €100.000",
      "100-150k": "€100.000 – €150.000",
      "150-250k": "€150.000 – €250.000",
      gt250k: "Plus de €250.000",
      unknown: "Budget non défini",
    },
    budgetNote: "Ceci n'est qu'une indication et nous aide à mieux estimer votre demande. Aucun prix automatique n'est déterminé.",
    starttermijn: {
      asap: "Dès que possible",
      "1m": "Dans le mois",
      "1-3m": "Dans 1–3 mois",
      "3-6m": "Dans 3–6 mois",
      "6-12m": "Dans 6–12 mois",
      later: "Plus tard",
      unknown: "Non défini",
    },
    deadlineQ: "Y a-t-il une date de livraison souhaitée ou une échéance ?",
    deadlineYes: "Oui",
    deadlineNo: "Non",
    deadlineDate: "Date de livraison souhaitée",
    plaatsbezoek: "Date souhaitée pour la visite (facultatif)",
    loc: { straat: "Rue", huisnummer: "N°", postcode: "Code postal", gemeente: "Commune", land: "Pays" },
    upload: {
      title: "Photos et plans",
      hint: "JPG, PNG, WebP ou PDF · max. 10 fichiers",
      add: "Ajouter des fichiers",
      uploading: "Téléchargement…",
      remove: "Supprimer",
    },
    contact: {
      voornaam: "Prénom", achternaam: "Nom", telefoon: "Téléphone", email: "E-mail",
      bedrijf: "Nom de l'entreprise", btw: "Numéro de TVA", opmerkingen: "Remarques",
    },
    priceNote:
      "Un devis définitif ne sera établi qu'après évaluation du projet et, si nécessaire, une visite sur place.",
    errType: "Sélectionnez au moins un type.",
    errContact: "Indiquez vos prénom, nom, téléphone et e-mail.",
    errEmail: "Indiquez une adresse e-mail valide.",
    errFail: "Échec de l'envoi. Réessayez ou appelez-nous.",
  },
  confirmation: {
    title: "Merci pour votre demande",
    body:
      "Nous avons bien reçu les détails de votre projet. VHM Renovation examine votre demande et vous contactera pour discuter des possibilités et d'une éventuelle visite.",
    note:
      "Un devis définitif ne sera établi qu'après évaluation du projet et, si nécessaire, une visite sur place.",
    home: "Retour à l'accueil",
  },
};

const EN = {
  meta: {
    title: "VHM Renovation | Painting & finishing works — Brussels South & Brabant",
    description:
      "Painting and finishing works: interior and exterior painting, drywall, plastering and floor covering. Neat finish, 2-year warranty. Request your quote.",
  },
  common: {
    requestQuote: "Request a quote",
    quoteShort: "Request a quote",
    callUs: "Call VHM Renovation",
    viewWork: "View our work",
    back: "Back",
    next: "Next",
    submit: "Send request",
    sending: "Sending…",
    optional: "optional",
    stepOf: "Step {n} of {total}",
  },
  nav: [
    { label: "Services", page: "services" },
    { label: "Projects", page: "realisaties" },
    { label: "Process", page: "process" },
    { label: "Region", page: "region" },
  ],
  hero: {
    badge: "Painting & finishing · 15+ years' experience",
    titleTop: "Painting & finishing works",
    titleMain: "A crisp, careful finish — inside and out.",
    subtitle:
      "VHM Renovation handles painting, drywall, plastering and floor covering for homes, apartments and commercial spaces. Craftsmanship with an eye for detail.",
    primary: "Request a quote",
    secondary: "View our work",
    stats: [
      { v: "15+", l: "Years' experience" },
      { v: "2 yr", l: "Warranty on work" },
      { v: "Insured", l: "Liability cover" },
    ],
  },
  services: {
    label: "Services",
    title: "Painting & finishing works",
    intro:
      "From preparation to the final coat: VHM Renovation delivers a clean, durable finish with quality materials.",
    items: [
      { name: "Interior painting", desc: "Walls and ceilings painted, as standard in at least two coats." },
      { name: "Exterior painting & façade", desc: "Façades, frames and woodwork, weather-resistant finish." },
      { name: "Drywall partitions", desc: "Installing plasterboard walls and partitions." },
      { name: "Plastering & sanding", desc: "Perfectly smooth walls and ceilings, ready to paint." },
      { name: "Repairs", desc: "Cracks, holes and imperfections expertly repaired." },
      { name: "Floor covering", desc: "Laying and finishing floor coverings." },
      { name: "Wallpapering", desc: "Neatly hung wallpaper, including non-woven." },
      { name: "Preparation & cleaning", desc: "Masking, covering and cleaning all surfaces." },
    ],
  },
  why: {
    label: "Why VHM Renovation",
    title: "Guaranteed craftsmanship, neatly delivered",
    items: [
      { title: "15+ years' experience", desc: "Years of experience in painting and finishing." },
      { title: "2-year warranty", desc: "On all work — craftsmanship and materials." },
      { title: "Insured (liability)", desc: "Fully insured throughout the works." },
      { title: "Neat, punctual site", desc: "A fixed point of contact and a clean, safe site." },
    ],
  },
  process: {
    label: "Process",
    title: "How your project unfolds",
    intro: "A clear four-step journey — transparent and without surprises.",
    steps: [
      { title: "Request", desc: "Describe your project via our form — including photos." },
      { title: "Site visit & advice", desc: "We assess the surfaces and advise you honestly." },
      { title: "Clear quote", desc: "You receive a clear quote tailored to your project." },
      { title: "Execution & handover", desc: "We carry out the works neatly and hand over clean." },
    ],
  },
  realisaties: {
    label: "Projects",
    title: "Work that speaks for itself",
    intro: "A selection of our painting and finishing projects. Quality you can see and feel.",
    tags: ["Interior painting", "Façade & exterior", "Drywall & finishing", "Floor covering"],
  },
  team: {
    label: "Craftsmanship",
    title: "Personal craftsmanship on every site",
    body: "At VHM Renovation you work with an experienced, dedicated craftsman. One point of contact, clear agreements and a careful finish from start to handover.",
    points: ["15+ years' experience", "Fixed point of contact", "Clean, safe site", "Quality materials"],
  },
  region: {
    label: "Service area",
    title: "Active in Rhode-Saint-Genèse, South Brussels & surroundings",
    body:
      "VHM Renovation is based in Sint-Genesius-Rode and works across South Brussels, the periphery and Walloon & Flemish Brabant.",
    note: "Outside this region? Get in touch — we consider every project.",
    cities: ["Sint-Genesius-Rode", "Uccle", "Linkebeek", "Drogenbos", "Beersel", "Waterloo", "Halle", "Brussels"],
  },
  ctaBand: {
    title: "Ready for an impeccable finish?",
    body: "Send us your project details. We review your request and get in touch with a quote.",
    button: "Request a quote",
    or: "or",
    call: "Call VHM Renovation",
  },
  footer: {
    blurb: "Painting and finishing works for homes, apartments and commercial spaces. Inside and out, neatly finished.",
    contactLabel: "Contact",
    servicesLabel: "Services",
    services: ["Interior painting", "Façade & exterior", "Drywall & plastering", "Floor covering"],
    areaLabel: "Service area",
    area: "Sint-Genesius-Rode · Uccle · Linkebeek · Drogenbos · Beersel · Waterloo · Halle · Brussels",
    legal: "© 2026 VHM Renovation — Painting & finishing.",
    adminLink: "Admin",
  },
  wizard: {
    heading: "Quote request",
    sub: "Tell us about your project. The more complete your request, the better we can estimate it.",
    steps: [
      { t: "Project type", s: "What do you want done?" },
      { t: "Scope", s: "How large is the project?" },
      { t: "Works", s: "Which works are needed?" },
      { t: "Budget", s: "Your estimated budget" },
      { t: "Timing", s: "When do you want to start?" },
      { t: "Location", s: "Where is the project?" },
      { t: "Photos & contact", s: "Almost done" },
    ],
    q: {
      type: "What would you like done?",
      size: "Roughly how large is the project?",
      works: "Which works are needed?",
      budget: "What is your estimated budget?",
      planning: "When do you want to start?",
      location: "What is the project address?",
      contact: "Photos, plans and contact details",
    },
    projectHint: "Multiple options possible.",
    projectTypes: {
      woning: "House",
      appartement: "Apartment",
      nieuwbouw: "New build",
      handelsruimte: "Commercial space",
      kantoor: "Office",
      andere: "Other",
    },
    size: {
      oppervlakte: "Estimated area (m²)",
      verdiepingen: "Number of floors",
      kamers: "Number of rooms",
      bouwjaar: "Year built",
      bewoond: "Is the property currently occupied?",
      renoType: "Whole property or a few rooms?",
    },
    bewoond: { ja: "Yes", nee: "No", onbekend: "Unknown" },
    renoType: { volledig: "Whole property", gedeeltelijk: "A few rooms", onzeker: "Not sure yet" },
    worksCats: {
      schilderwerk: "Painting",
      afwerking: "Drywall & finishing",
      voorbereiding: "Preparation",
    },
    works: {
      binnen: "Interior painting", buiten: "Exterior painting & façade", plafonds: "Ceilings", behang: "Wallpapering",
      gyproc: "Install drywall partitions", plamuren: "Plastering & sanding", herstellingen: "Repair cracks & holes", vloerbekleding: "Lay floor covering",
      reinigen: "Cleaning & degreasing", afplakken: "Masking & covering", schuren: "Sanding & priming",
    },
    worksDesc: "Briefly describe what you want carried out.",
    worksDescPh: "E.g. paint the living room and hallway (walls + ceiling) and install a drywall partition…",
    budget: {
      lt10k: "Less than €10,000",
      "10-25k": "€10,000 – €25,000",
      "25-50k": "€25,000 – €50,000",
      "50-100k": "€50,000 – €100,000",
      "100-150k": "€100,000 – €150,000",
      "150-250k": "€150,000 – €250,000",
      gt250k: "More than €250,000",
      unknown: "No budget set yet",
    },
    budgetNote: "This is only an indication and helps us estimate your request. No automatic price is determined.",
    starttermijn: {
      asap: "As soon as possible",
      "1m": "Within 1 month",
      "1-3m": "Within 1–3 months",
      "3-6m": "Within 3–6 months",
      "6-12m": "Within 6–12 months",
      later: "Later",
      unknown: "Not defined",
    },
    deadlineQ: "Is there a desired completion date or deadline?",
    deadlineYes: "Yes",
    deadlineNo: "No",
    deadlineDate: "Desired completion date",
    plaatsbezoek: "Preferred site-visit date (optional)",
    loc: { straat: "Street", huisnummer: "No.", postcode: "Postal code", gemeente: "Municipality", land: "Country" },
    upload: {
      title: "Photos and plans",
      hint: "JPG, PNG, WebP or PDF · max. 10 files",
      add: "Add files",
      uploading: "Uploading…",
      remove: "Remove",
    },
    contact: {
      voornaam: "First name", achternaam: "Last name", telefoon: "Phone number", email: "Email address",
      bedrijf: "Company name", btw: "VAT number", opmerkingen: "Additional notes",
    },
    priceNote:
      "A final quote is only drawn up after assessment of the project and, if necessary, a site visit.",
    errType: "Select at least one type.",
    errContact: "Enter your first name, last name, phone and email.",
    errEmail: "Enter a valid email address.",
    errFail: "Sending failed. Please try again or call us.",
  },
  confirmation: {
    title: "Thank you for your request",
    body:
      "We have received your project details. VHM Renovation will review your request and contact you to discuss the possibilities and a possible site visit.",
    note:
      "A final quote is only drawn up after assessment of the project and, if necessary, a site visit.",
    home: "Back to homepage",
  },
};

const ES = {
  meta: {
    title: "VHM Renovation | Pintura y acabados — Bruselas Sur y Brabante",
    description:
      "Pintura y trabajos de acabado: pintura interior y exterior, pladur, enlucido y revestimiento de suelos. Acabado impecable, 2 años de garantía. Solicite su presupuesto.",
  },
  common: {
    requestQuote: "Solicite un presupuesto",
    quoteShort: "Solicitar presupuesto",
    callUs: "Llame a VHM Renovation",
    viewWork: "Ver nuestros trabajos",
    back: "Anterior",
    next: "Siguiente",
    submit: "Enviar solicitud",
    sending: "Enviando…",
    optional: "opcional",
    stepOf: "Paso {n} de {total}",
  },
  nav: [
    { label: "Servicios", page: "services" },
    { label: "Proyectos", page: "realisaties" },
    { label: "Método", page: "process" },
    { label: "Región", page: "region" },
  ],
  hero: {
    badge: "Pintura y acabados · 15+ años de experiencia",
    titleTop: "Pintura y trabajos de acabado",
    titleMain: "Un acabado impecable y cuidado, dentro y fuera.",
    subtitle:
      "VHM Renovation realiza pintura, pladur, enlucido y revestimiento de suelos para viviendas, apartamentos y espacios profesionales. Trabajo cuidado, con atención al detalle.",
    primary: "Solicite un presupuesto",
    secondary: "Ver nuestros trabajos",
    stats: [
      { v: "15+", l: "Años de experiencia" },
      { v: "2 años", l: "Garantía en el trabajo" },
      { v: "RC", l: "Asegurado" },
    ],
  },
  services: {
    label: "Servicios",
    title: "Pintura y trabajos de acabado",
    intro:
      "De la preparación a la última capa: VHM Renovation ofrece un acabado limpio y duradero con materiales de calidad.",
    items: [
      { name: "Pintura interior", desc: "Paredes y techos pintados, por norma en dos capas." },
      { name: "Pintura exterior y fachada", desc: "Fachadas, marcos y carpintería, acabado resistente." },
      { name: "Tabiques de pladur", desc: "Colocación de tabiques y paredes de pladur." },
      { name: "Enlucido y lijado", desc: "Paredes perfectamente lisas, listas para pintar." },
      { name: "Reparaciones", desc: "Grietas, agujeros e imperfecciones reparados con cuidado." },
      { name: "Revestimiento de suelos", desc: "Colocación y acabado de revestimientos de suelo." },
      { name: "Colocación de papel pintado", desc: "Papel pintado colocado con precisión." },
      { name: "Preparación y limpieza", desc: "Protección, cubrición y limpieza de superficies." },
    ],
  },
  why: {
    label: "Por qué VHM Renovation",
    title: "Trabajo garantizado, entregado con esmero",
    items: [
      { title: "15+ años de experiencia", desc: "Años de experiencia en pintura y acabados." },
      { title: "2 años de garantía", desc: "En todos los trabajos — mano de obra y materiales." },
      { title: "Asegurado (RC)", desc: "Totalmente asegurado durante toda la ejecución." },
      { title: "Obra limpia y puntual", desc: "Un interlocutor fijo y una obra limpia y segura." },
    ],
  },
  process: {
    label: "Método",
    title: "Cómo se desarrolla su proyecto",
    intro: "Un proceso claro en cuatro pasos — transparente y sin sorpresas.",
    steps: [
      { title: "Solicitud", desc: "Describa su proyecto en nuestro formulario — con fotos." },
      { title: "Visita y asesoramiento", desc: "Evaluamos las superficies y le asesoramos con honestidad." },
      { title: "Presupuesto claro", desc: "Recibe un presupuesto claro y a medida de su proyecto." },
      { title: "Ejecución y entrega", desc: "Ejecutamos con esmero y entregamos limpio." },
    ],
  },
  realisaties: {
    label: "Proyectos",
    title: "Un trabajo que habla por sí solo",
    intro: "Una muestra de nuestros trabajos de pintura y acabado. Calidad que se ve y se siente.",
    tags: ["Pintura interior", "Fachada y exterior", "Pladur y acabado", "Revestimiento de suelo"],
  },
  team: {
    label: "Oficio",
    title: "Oficio personal en cada obra",
    body: "En VHM Renovation trabaja con un profesional experimentado y fijo. Un único interlocutor, acuerdos claros y un acabado cuidado desde el inicio hasta la entrega.",
    points: ["15+ años de experiencia", "Interlocutor fijo", "Obra limpia y segura", "Materiales de calidad"],
  },
  region: {
    label: "Zona de trabajo",
    title: "Activos en Rhode-Saint-Genèse, Bruselas Sur y alrededores",
    body:
      "VHM Renovation tiene su sede en Sint-Genesius-Rode y trabaja en Bruselas Sur, la periferia y el Brabante valón y flamenco.",
    note: "¿Fuera de esta región? Contáctenos — estudiamos cada proyecto.",
    cities: ["Sint-Genesius-Rode", "Uccle", "Linkebeek", "Drogenbos", "Beersel", "Waterloo", "Halle", "Bruselas"],
  },
  ctaBand: {
    title: "¿Listo para un acabado impecable?",
    body: "Envíenos los detalles de su proyecto. Revisamos su solicitud y le contactamos con un presupuesto.",
    button: "Solicite un presupuesto",
    or: "o",
    call: "Llame a VHM Renovation",
  },
  footer: {
    blurb: "Pintura y trabajos de acabado para viviendas, apartamentos y espacios profesionales. Interior y exterior, con acabado impecable.",
    contactLabel: "Contacto",
    servicesLabel: "Servicios",
    services: ["Pintura interior", "Fachada y exterior", "Pladur y enlucido", "Revestimiento de suelo"],
    areaLabel: "Zona de trabajo",
    area: "Sint-Genesius-Rode · Uccle · Linkebeek · Drogenbos · Beersel · Waterloo · Halle · Bruselas",
    legal: "© 2026 VHM Renovation — Pintura y acabados.",
    adminLink: "Gestión",
  },
  wizard: {
    heading: "Solicitud de presupuesto",
    sub: "Cuéntenos sobre su proyecto. Cuanto más completa sea su solicitud, mejor podremos estimarla.",
    steps: [
      { t: "Tipo de proyecto", s: "¿Qué desea realizar?" },
      { t: "Alcance", s: "¿Qué tamaño tiene el proyecto?" },
      { t: "Trabajos", s: "¿Qué trabajos se necesitan?" },
      { t: "Presupuesto", s: "Su presupuesto estimado" },
      { t: "Planificación", s: "¿Cuándo desea empezar?" },
      { t: "Ubicación", s: "¿Dónde está el proyecto?" },
      { t: "Fotos y contacto", s: "Casi listo" },
    ],
    q: {
      type: "¿Qué le gustaría realizar?",
      size: "¿Qué tamaño tiene aproximadamente el proyecto?",
      works: "¿Qué trabajos se necesitan?",
      budget: "¿Cuál es su presupuesto estimado?",
      planning: "¿Cuándo desea empezar?",
      location: "¿Cuál es la dirección del proyecto?",
      contact: "Fotos, planos y datos de contacto",
    },
    projectHint: "Se pueden elegir varias opciones.",
    projectTypes: {
      woning: "Vivienda",
      appartement: "Apartamento",
      nieuwbouw: "Obra nueva",
      handelsruimte: "Espacio comercial",
      kantoor: "Oficina",
      andere: "Otro",
    },
    size: {
      oppervlakte: "Superficie estimada (m²)",
      verdiepingen: "Número de plantas",
      kamers: "Número de estancias",
      bouwjaar: "Año de construcción",
      bewoond: "¿El inmueble está actualmente habitado?",
      renoType: "¿Todo el inmueble o algunas estancias?",
    },
    bewoond: { ja: "Sí", nee: "No", onbekend: "Desconocido" },
    renoType: { volledig: "Todo el inmueble", gedeeltelijk: "Algunas estancias", onzeker: "Aún no seguro" },
    worksCats: {
      schilderwerk: "Pintura",
      afwerking: "Pladur y acabado",
      voorbereiding: "Preparación",
    },
    works: {
      binnen: "Pintura interior", buiten: "Pintura exterior y fachada", plafonds: "Techos", behang: "Papel pintado",
      gyproc: "Colocar tabiques de pladur", plamuren: "Enlucido y lijado", herstellingen: "Reparar grietas y agujeros", vloerbekleding: "Colocar revestimiento de suelo",
      reinigen: "Limpieza y desengrase", afplakken: "Protección y cubrición", schuren: "Lijado e imprimación",
    },
    worksDesc: "Describa brevemente lo que desea realizar.",
    worksDescPh: "P.ej. pintar el salón y el pasillo (paredes + techo) y colocar un tabique de pladur…",
    budget: {
      lt10k: "Menos de €10.000",
      "10-25k": "€10.000 – €25.000",
      "25-50k": "€25.000 – €50.000",
      "50-100k": "€50.000 – €100.000",
      "100-150k": "€100.000 – €150.000",
      "150-250k": "€150.000 – €250.000",
      gt250k: "Más de €250.000",
      unknown: "Presupuesto sin definir",
    },
    budgetNote: "Esto es solo una indicación y nos ayuda a estimar mejor su solicitud. No se determina ningún precio automático.",
    starttermijn: {
      asap: "Lo antes posible",
      "1m": "En 1 mes",
      "1-3m": "En 1–3 meses",
      "3-6m": "En 3–6 meses",
      "6-12m": "En 6–12 meses",
      later: "Más adelante",
      unknown: "Sin definir",
    },
    deadlineQ: "¿Hay una fecha de entrega deseada o un plazo?",
    deadlineYes: "Sí",
    deadlineNo: "No",
    deadlineDate: "Fecha de entrega deseada",
    plaatsbezoek: "Fecha preferida para la visita (opcional)",
    loc: { straat: "Calle", huisnummer: "Nº", postcode: "Código postal", gemeente: "Municipio", land: "País" },
    upload: {
      title: "Fotos y planos",
      hint: "JPG, PNG, WebP o PDF · máx. 10 archivos",
      add: "Añadir archivos",
      uploading: "Subiendo…",
      remove: "Eliminar",
    },
    contact: {
      voornaam: "Nombre", achternaam: "Apellido", telefoon: "Teléfono", email: "Correo electrónico",
      bedrijf: "Nombre de empresa", btw: "Número de IVA", opmerkingen: "Comentarios",
    },
    priceNote:
      "Un presupuesto definitivo solo se elabora tras la evaluación del proyecto y, si es necesario, una visita.",
    errType: "Seleccione al menos un tipo.",
    errContact: "Indique su nombre, apellido, teléfono y correo electrónico.",
    errEmail: "Indique un correo electrónico válido.",
    errFail: "Error al enviar. Inténtelo de nuevo o llámenos.",
  },
  confirmation: {
    title: "Gracias por su solicitud",
    body:
      "Hemos recibido los detalles de su proyecto. VHM Renovation revisará su solicitud y se pondrá en contacto con usted para hablar de las posibilidades y una posible visita.",
    note:
      "Un presupuesto definitivo solo se elabora tras la evaluación del proyecto y, si es necesario, una visita.",
    home: "Volver al inicio",
  },
};

export const CONTENT = { nl: NL, fr: FR, en: EN, es: ES };
